<script lang="ts">
	import { cn } from "#lib/web-ui/ui/utils.js";
	import { Section, SectionHeader, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import CheckIcon from "@lucide/svelte/icons/check";

	interface FeatureItem {
		title: string;
		description: string;
		bulletPoints?: string[];
		image: string;
		imageAlt?: string;
	}

	interface Props {
		id?: string;
		label?: string;
		title?: string;
		subtitle?: string;
		items: FeatureItem[];
		theme?: SectionTheme;
		class?: string;
	}

	let { id, label, title, subtitle, items, theme = "light", class: className }: Props = $props();
</script>

<Section {id} {theme} class={className}>
	<SectionHeader {label} {title} {subtitle} />

	<div class="space-y-16">
		{#each items as item, i (item.title)}
			<div
				class={cn(
					"flex flex-col items-center gap-8 lg:gap-12",
					i % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
				)}
			>
				<div class="w-full lg:w-1/2">
					<div class="overflow-hidden rounded shadow-lg">
						<img
							src={item.image}
							alt={item.imageAlt ?? item.title}
							class="h-72 w-full object-cover"
							width="600"
							height="288"
							loading="lazy"
						/>
					</div>
				</div>

				<div class="w-full lg:w-1/2">
					<h3 class="text-foreground mb-4 text-2xl font-bold">{item.title}</h3>
					<p class="text-muted-foreground mb-6 text-lg">{item.description}</p>
					{#if item.bulletPoints?.length}
						<ul class="space-y-3">
							{#each item.bulletPoints as point (point)}
								<li class="flex items-start gap-3">
									<span class="text-primary mt-1">
										<CheckIcon class="h-4 w-4" />
									</span>
									<span class="text-muted-foreground">{point}</span>
								</li>
							{/each}
						</ul>
					{/if}
				</div>
			</div>
		{/each}
	</div>
</Section>
